import { Apprentice } from '../../../../model/person.model'
import { findApprenticeById } from '../../../../util/arraySearch'

export const InactiveRowStyle = (entity: any) => {
  return {
    'inactive-row': entity.is_active === 0,
  }
}

export const InactiveRowStyleByObjectAndPerson = (
  entity: any,
  id_apprentice: number | undefined,
  apprentices: Apprentice[]
) => {
  if (!id_apprentice) {
    return 'inactive-row'
  }
  const p = findApprenticeById(id_apprentice, apprentices)
  return {
    'inactive-row': entity.is_active === 0 || p?.is_active !== 1,
  }
}